import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'

import { SENTRY_CONFIG } from 'src/config'
import { env } from 'src/env'
import { trimTransactionName } from 'src/resources/utils/trimTransactionName'

/**
 * Conditionally initialize Sentry tracking
 */
export const sentryInit = () => {
  if (SENTRY_CONFIG.enabled) {
    Sentry.init({
      debug: SENTRY_CONFIG.debug,
      dsn: SENTRY_CONFIG.dsn,
      environment: SENTRY_CONFIG.environment,
      release: env.COMMIT_REF || SENTRY_CONFIG.release,
      tracesSampleRate: parseFloat(env.SENTRY_TRACES_SAMPLE_RATE || '0.1'),
      integrations: [
        new Integrations.BrowserTracing({
          tracingOrigins: ['api.us.flatfile.io', 'api.flatfile.io'],
          routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
          beforeNavigate: (context) => {
            return {
              ...context,
              name: trimTransactionName(location.pathname)
            }
          }
        })
      ]
    })
  }
}
